import { render } from "./Normativas.vue?vue&type=template&id=16e5bf57"
import script from "./Normativas.vue?vue&type=script&lang=js"
export * from "./Normativas.vue?vue&type=script&lang=js"

import "./Normativas.vue?vue&type=style&index=0&id=16e5bf57&lang=css"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__